import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import SignInComp from "../features/authentication/SignIn";
import { getUserAndToHome } from "../utils/user";
import { useLoginTimeout } from "../hooks/useLoginTimeout";

const SignIn = () => {
  const navigate = useNavigate();

  // ログイン画面タイムアウト（5分）
  useLoginTimeout(5);

  /**
   * 既にsigninの場合ホームページへ遷移
   */
  useEffect(() => {
    getUserAndToHome(navigate);
  }, [navigate]);

  return <SignInComp />;
};

export default SignIn;
